const generateRandomId = () => {
  return Math.floor(100 + Math.random() * 900);
};

export default generateRandomId;
